import React from 'react';
import { Box, TextField } from '@mui/material';

type Device = {
  id: string;
  name: string;
  owner: string;
  type: string;
  status: string;
  updated: string;
};

interface Props {
  device: Device | null;
  onChange: (d: Device) => void;
}

export default function DeviceForm({ device, onChange }: Props) {
  if (!device) return null;
  return (
    <Box sx={{ mt: 1 }}>
      <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
        <Box>
          <TextField fullWidth label="ID" value={device.id} onChange={(e) => onChange({ ...device, id: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="Device Name" value={device.name} onChange={(e) => onChange({ ...device, name: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="Device Owner" value={device.owner} onChange={(e) => onChange({ ...device, owner: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="Device Type" value={device.type} onChange={(e) => onChange({ ...device, type: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="Status" value={device.status} onChange={(e) => onChange({ ...device, status: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="Last Updated" value={device.updated} onChange={(e) => onChange({ ...device, updated: e.target.value })} placeholder="DD/MM/YYYY" />
        </Box>
      </Box>
    </Box>
  );
}
